module.exports = __webpack_public_path__ + "img/mp3.4b55b30.svg";